export type Purchase = { name: string; city: string; country: string; minutesAgo: number };

export const purchases: Purchase[] = [
  { name: 'María G.', city: 'Buenos Aires', country: 'Argentina', minutesAgo: 2 },
  { name: 'José R.', city: 'Ciudad de México', country: 'México', minutesAgo: 4 },
  { name: 'Ana L.', city: 'Bogotá', country: 'Colombia', minutesAgo: 6 },
  { name: 'Carlos M.', city: 'Lima', country: 'Perú', minutesAgo: 3 },
  { name: 'Lucía F.', city: 'Santiago', country: 'Chile', minutesAgo: 8 },
  { name: 'Pedro S.', city: 'Montevideo', country: 'Uruguay', minutesAgo: 5 },
  { name: 'Rosa P.', city: 'Guayaquil', country: 'Ecuador', minutesAgo: 1 },
  { name: 'Daniel V.', city: 'Asunción', country: 'Paraguay', minutesAgo: 7 },
  { name: 'Carmen D.', city: 'Santo Domingo', country: 'Rep. Dominicana', minutesAgo: 9 },
  { name: 'Miguel A.', city: 'Miami', country: 'Estados Unidos', minutesAgo: 4 },
  { name: 'Sofía T.', city: 'San José', country: 'Costa Rica', minutesAgo: 2 },
  { name: 'Jorge H.', city: 'Guatemala', country: 'Guatemala', minutesAgo: 6 },
  { name: 'Patricia C.', city: 'La Paz', country: 'Bolivia', minutesAgo: 3 },
  { name: 'Luis E.', city: 'Caracas', country: 'Venezuela', minutesAgo: 5 },
  { name: 'Gabriela N.', city: 'San Juan', country: 'Puerto Rico', minutesAgo: 8 },
  { name: 'Fernando B.', city: 'Córdoba', country: 'Argentina', minutesAgo: 1 },
];
